import './index.less';

import { useMemo, useState } from 'react';
import AnimatedNumber from 'animated-number-react';
import classNames from 'classnames';

type Props = {
  value: number;
  decimalDigits?: number;
  currency?: string;
  useAnimation?: boolean;
  animClassName?: string | 'yellow' | 'purple' | 'green';
  TextLineThrough?: boolean;
};
export const RevxMoney = ({
  value,
  currency,
  decimalDigits = 2,
  useAnimation,
  animClassName,
  TextLineThrough,
}: Props) => {
  const [curAnimCls, setCurAnimCls] = useState('');
  return useMemo(() => {
    return !useAnimation ? (
      <span
        className={classNames('revx-money', {
          lineThrough: TextLineThrough,
        })}
      >
        {new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency || 'USD',
          minimumFractionDigits: decimalDigits ?? 2,
        }).format(value)}
      </span>
    ) : (
      <span
        className={classNames('revx-money', curAnimCls, {
          animation: useAnimation,
        })}
        style={{ display: 'inline-flex' }}
      >
        <AnimatedNumber
          formatValue={(value) =>
            `$${decimalDigits ? Number(value).toFixed(decimalDigits) : value}`
          }
          value={value}
          begin={() => {
            setCurAnimCls(animClassName || '');
          }}
          complete={() => {
            setCurAnimCls('');
          }}
        />
      </span>
    );
  }, [
    animClassName,
    curAnimCls,
    currency,
    decimalDigits,
    useAnimation,
    value,
    TextLineThrough,
  ]);
};
